<template>
    <console-content max-width="1280">

        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">
                <span v-if="$route.params._partner">제휴업체 상세</span>
                <span v-else>제휴업체 생성</span>
            </v-col>
            <v-spacer/>
        </v-row>

        <v-row class="mt-3">
            <v-col cols="12" md="8" class="py-0 pr-md-1">
                <v-card class="mx-1" :disabled="!$hasScope(['root', 'admin'])">
                    <v-card-title class="subtitle-2">기본정보</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col class="py-0">
                                <v-text-field v-model="partner.username" label="아이디" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-password-field v-model="partner.password" label="비밀번호" placeholder=" " hide-details></v-password-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col class="py-0">
                                <v-text-field v-model="partner.name" label="담당자(이름)" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col class="py-0">
                                <v-text-field v-model="partner.phone" label="담당자(연락처)" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field v-model="partner.email" label="담당자(이메일)" placeholder=" " hide-details></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col class="py-0">
                                <v-text-field v-model="partner.postcode" label="우편번호" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col class="py-0">
                                <v-text-field v-model="partner.address1" label="기본주소" placeholder=" " hide-details></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field v-model="partner.address2" label="상세주소" placeholder=" " hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions/>
                </v-card>
            </v-col>

            <v-col cols="12" md="4" class="py-0 pl-md-1">
                <v-card class="mx-1 mt-3 mt-md-0" :disabled="!$hasScope(['root', 'admin'])">
                    <v-card-title class="subtitle-2">제휴정보</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="partner.companyName" label="업체명" placeholder=" " hide-details></v-text-field>
                        <v-text-field v-model="partner.organization" label="organization(mid)" placeholder=" " hide-details class="mt-4"></v-text-field>
                        <v-text-field v-model="partner.code" label="code" placeholder=" " hide-details class="mt-4"></v-text-field>
                        <v-text-field v-model="partner.key" label="key" placeholder=" " hide-details class="mt-4"></v-text-field>
                        <v-text-field v-model="partner.iv" label="iv" placeholder=" " hide-details class="mt-4"></v-text-field>
                        <v-text-field v-model="partner.jwt" label="jwt" placeholder=" " hide-details class="mt-4"></v-text-field>
                    </v-card-text>
                    <v-card-actions/>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="my-6">
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn :disabled="!$hasScope(['root', 'admin'])" color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

    </console-content>
</template>

<script>
import api from "@/api";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent,
        VPasswordField
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            partner: {
                username: null,
                password: null,
                name: null,
                phone: null,
                email: null,
                postcode: null,
                address1: null,
                address2: null,

                companyName: null,
                organization: null,
                code: null,
                key: null,
                iv: null,
                jwt: null
            }
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            if(this.$route.params._partner){
                let { partner } = await api.console.partners.get({ _id: this.$route.params._partner });
                this.partner = {
                    ...this.partner,
                    ...partner
                };
            }
        },

        async save(){
            this.partner._id ? await api.console.partners.put(this.partner) : await api.console.partners.post(this.partner);
            alert("저장되었습니다");
            this.$router.push(`/console/partners`);
        }
    }
}
</script>